<template>
    <div class="video-details-container mainContainer pbottom50"  v-visibility-change="change" v-cloak>
        <div class="w11" >
            <!-- 面包屑 -->
            <bread-crumb
                firstPath="/pcViews/learn"
                firstNav="在线学习"
                secondPath="/pcViews/learn/train"
                secondNav="教育培训"
                :breadcrumbText="courseName"
            ></bread-crumb>
            <div class="shouldNnow">
                温馨提示：在观看视频教材时，禁止拖拽视频、倍速播放、及使用刷课软件听课，否则听课视为无效
            </div>
            <!-- 课程信息模块 -->
            <course-module>
                <!-- 课程基本信息开始 -->
                <course-content :isPurchase="isPurchase">
                    <div
                        class="course-video"
                        slot="course-video"
                        v-if="isPurchase"
                    >
                        <video
                            v-if="videoSource == 'txy'"
                            id="player-container-id"
                            ref="videoPlayer"
                            width="716"
                            height="406"
                            preload="auto"
                            @pause="pauseFunc($event)"
                            @ended="playEnded"
                            @play="playFunc"
                            @timeupdate="onPlayerTimeupdate($event)"
                            playsinline
                            webkit-playsinline
                        >
                        </video>
                        <vue-core-video-player
                            v-if="videoSource == 'lty'"
                            ref="videoPlayer"
                            id="video"
                            type="application/x-mpegURL"
                            :autoplay="autoplay"
                            :src="videoUrl"
                            @pause="pauseFunc($event)"
                            @ended="playEnded"
                            @play="playFunc"
                            @timeupdate="onPlayerTimeupdate($event)"
                        ></vue-core-video-player>
                    </div>
                    <p slot="course-purchase-num">{{buyCount}}</p>
                    <p slot="course-purchase-hour">{{totalPeriod}}</p>
                    <!-- <div class="purchaseTipsBox" slot="purchaseTipsBox" v-if="!isPurchase">
                        <purchase-tips >
                            <span @click="purchase" slot="purchase"> 立即购买 </span>
                        </purchase-tips>
                    </div>
                    <p slot="course-purchase-num">{{buyCount}}</p>
                    <p slot="course-purchase-hour">{{totalPeriod}}</p>
                    <div class="course_title" slot="course_title">
                        {{courseName}}
                    </div>
                    <h4 slot="real_price">53.0元</h4>
                    <div class="course_lecturer_list" slot="course_lecturer_list">
                        <span> 王二小 </span>
                        <span> 王二小 </span>
                    </div>
                    <span slot="startTime">2022-09-01 00:00:00</span>
                    <span slot="endTime">2022-10-31 23:59:59</span>
                    <div class="payBigBtn" @click="purchase" slot="payBigBtn">立即购买</div> -->
                    <div
                        class="course_chapter_item"
                        :class="[{ active: index === videoIndex }]"
                        slot="course_chapter_item"
                        v-for="(videoItem, index) in videoList"
                        :key="videoItem.id"
                        @click="changeChapter(videoItem, index)"
                    >
                        <div class="chapter_title">
                            <p>录播</p>
                            <div>
                                {{ videoItem.coursewareVideo.name }}
                            </div>
                        </div>
                        <div class="time">
                            {{
                                durationTrans(
                                    videoItem.coursewareVideo.totalDuration
                                )
                            }}分钟
                        </div>
                    </div>
                </course-content>
                <!-- 课程基本信息结束 -->
                <!-- 课程相关信息开始 -->
                <course-correlation-info>
                    <!-- 选项卡开始 -->
                    <div class="course_info_tabs" slot="course_info_tabs">
                        <el-tabs
                            v-model="tabsName"
                            @tab-click="handleTabsClick"
                        >
                            <el-tab-pane
                                label="课程详情"
                                name="0"
                            ></el-tab-pane>
                            <el-tab-pane
                                label="课程大纲"
                                name="1"
                            ></el-tab-pane>
                            <!-- <el-tab-pane label="相关资料" name="2"></el-tab-pane> -->
                        </el-tabs>
                    </div>
                    <!-- 选项卡结束 -->
                    <!-- 讲师介绍开始 -->
                    <!-- <course-correlation-info-title slot="lecturers_introduce_title">
                        <img src="~assets/images/learn/titleImg1.png" alt="" slot="img">
                        <p class="textColor1" slot="text">讲师介绍</p>
                    </course-correlation-info-title>
                    <i class="el-icon-arrow-left" slot="el-icon-arrow-left"></i>
                    <i class="el-icon-arrow-right" slot="el-icon-arrow-right"></i>
                    <swiper
                        ref="mySwiper"
                        :options="swiperOption"
                        class="swiper-no-swiping"
                        slot="lecturers_swiper"
                    >
                        <swiper-slide v-for="i in 6" :key="i">
                            <div class="swiperContent">
                                <img
                                    src="~assets/images/temporary/lecturerImg1.png"
                                    alt=""
                                    class="lecturerImg"
                                />
                                <div class="content">
                                    <p class="ellipsis">王晓鸥</p>
                                    <div>
                                        <p>简介：</p>
                                        <span>
                                            自2011年开始在中国
                                            建筑工业出版社出版
                                            注册结构师考试辅导
                                            书。认真、负责，是
                                            我的一贯作风。
                                        </span>

                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper> -->
                    <!-- 讲师介绍结束 -->
                    <!-- 课程介绍开始 -->
                    <course-correlation-info-title
                        slot="course_introduce_title"
                    >
                        <img
                            src="~assets/images/learn/titleImg2.png"
                            alt=""
                            slot="img"
                        />
                        <p class="textColor2" slot="text">课程介绍</p>
                    </course-correlation-info-title>
                    <div
                        class="course_introduce_text"
                        slot="course_introduce_text"
                        v-html="articleUnescapeHtml(introduction)"
                    ></div>
                    <!-- 课程介绍结束 -->
                    <!-- 课程大纲开始 -->
                    <course-correlation-info-title slot="course_chapter_title">
                        <img
                            src="~assets/images/learn/titleImg3.png"
                            alt=""
                            slot="img"
                        />
                        <p class="textColor3" slot="text">课程大纲</p>
                    </course-correlation-info-title>
                    <div class="course_chapter_list" slot="course_chapter_list">
                        <div
                            class="course_chapter_item"
                            v-for="(videoItem,index) in videoList"
                            :key="videoItem.id"
                            @click="changeChapter(videoItem, index)"
                        >
                            <div class="course_chapter_item_title">
                                <img
                                    src="~assets/images/learn/chapterVideoImg.png"
                                    class="chapterVideoImg"
                                    alt=""
                                />
                                <div class="course_chapter_item_title_text">
                                    【录播】{{
                                            videoItem.coursewareVideo.name
                                    }}
                                </div>
                            </div>
                            <p class="course_chapter_duration">
                                视频时长：{{
                                    durationTrans(
                                        videoItem.coursewareVideo.totalDuration
                                    )
                                }}分钟
                            </p>
                        </div>
                    </div>
                    <!-- 课程大纲结束 -->
                    <!-- 相关资料开始 -->
                    <!-- <course-correlation-info-title slot="course_file_title">
                        <img src="~assets/images/learn/titleImg4.png" alt="" slot="img">
                        <p class="textColor4" slot="text">相关资料</p>
                    </course-correlation-info-title>
                    <div class="course_file_list" slot="course_file_list">
                        <div class="course_file_item" v-for="i in 6" :key="i">
                            <img src="~assets/images/learn/checkImg.png" class="course_file_checkImg" alt="" v-if="(i%2) == 0">
                            <img src="~assets/images/learn/checkImga.png" class="course_file_checkImg" alt=""  v-else>
                            <div class="course_file_item_text" v-if="(i%2) == 0">分公司都i分工就是的风格</div>
                            <div class="course_file_item_text"  v-else style="color:#3aa8f4">老牛逼流口水的分级管理会计士大夫立刻给</div>
                        </div>
                        <div class="course_file_download">下载</div>
                    </div> -->
                    <!-- 相关资料结束 -->
                </course-correlation-info>
                <!-- 课程相关信息结束 -->
            </course-module>
        </div>
    </div>
</template>

<script>
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import BreadCrumb from "components/contents/breadCrumb/BreadCrumb";
import CourseModule from "components/contents/courseModule/CourseModule";
import CourseCorrelationInfo from "components/contents/courseCorrelationInfo/CourseCorrelationInfo";
import CourseContent from "components/common/courseContent/CourseContent";
// import PurchaseTips from "components/common/purchaseTips/PurchaseTips";
import CourseCorrelationInfoTitle from "components/common/courseCorrelationInfoTitle/CourseCorrelationInfoTitle";

import { PcCookie, Key } from "@/utils/cookie";

import { unescapeHTML } from "utils/validate";

import { getCourseDetail, saveVideoTime, getTxyVideo } from "api/train";

export default {
    //components:{  BreadCrumb, CourseModule, CourseCorrelationInfo, CourseContent, PurchaseTips, CourseCorrelationInfoTitle },
    components: {
        BreadCrumb,
        CourseModule,
        CourseCorrelationInfo,
        CourseContent,
        CourseCorrelationInfoTitle,
    },
    computed: {
        //文章转义字符
        articleUnescapeHtml() {
            return function (content) {
                return unescapeHTML(content);
            };
        },
        //视频时长转换成分钟
        durationTrans() {
            return function (totalDuration) {
                const mTime = Math.round((totalDuration / 60) * 100) / 100;
                return mTime;
            };
        },
        //视频名称 -- 去掉.mp4
        videoName() {
            return function (name) {
                let  vTxt = name;
                const suffix = name.substring(name.length - 4,name.length);
                if(suffix == '.mp4' || suffix == '.MP4'){//旧系统视频名称
                    vTxt = name.substring(0, name.length - 4);
                }else{//现系统的视频名称
                    vTxt = name.substring(3, name.length);
                }
                return vTxt;
            };
        },
    },
    data() {
        return {
            TCPlayerVideo: null,
            videoSource:"",
            tabsName: "", //选项卡标识
            buyCount: 0, //课程购买数量
            videoIndex: 0, //章节视频下标
            currentTime: 1, //视频播放时间
            courseName: "", //课程名称
            courseId: "", //课程id
            introduction: "", //课程简介
            totalPeriod: "", //课程总时长
            videoUrl: require("@/utils/1.mp4"),//视频路径
            videoList: [], //课程视频集合
            playVideoSrc: "", //当前播放视频src
            playVideo:{},
            hasNews: false, //获取数据flag
            isPurchase: true, //是否已购买
            isPlay: true, //是否暂停
            isChange: false,
            firstPlay: true, //第一次播放
            autoplay: false, //自动播放flag
            hasStudy: [], //是否学习过
        };
    },
    async mounted() {
        this.$nextTick(async () => {
            this.courseId = this.$route.query.courseId;
            this.trainId = this.$route.query.trainId;
            this.id = this.$route.query.id ? this.$route.query.id : '';
            await this.fetchCourseDetail();
            // 这里可以添加一个短暂的延迟，以确保数据更新
            if(this.videoSource == 'txy'){
                if(this.playVideo.coursewareVideo.id.includes('zyk-')){
                    this.queryTxyParams();
                }else{
                    this.queryTxyVideo(
                        this.playVideo.coursewareVideo.fileId,
                        this.playVideo.coursewareVideo.appId,
                        this.playVideo.coursewareVideo.psign,
                        this.playVideo.coursewareVideo.licenseUrl
                    );
                }
            }
        });
    },
    methods: {
        //获取腾讯云视频参数
        async queryTxyParams(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            const res = await getTxyVideo(sessionId,this.playVideo.coursewareVideo.id)
            this.queryTxyVideo(
                res.body.data.fileId,
                res.body.data.appId,
                res.body.data.psign,
                res.body.data.licenseUrl
            );
        },
        //获取腾讯云视频url
        queryTxyVideo(fileID,appID,psign,licenseUrl){
            this.TCPlayerVideo = TCPlayer('player-container-id', {
                fileID,appID,psign,licenseUrl
            });
            this.TCPlayerVideo.on('error', (err) => {
                console.error('TCPlayer error:', err);
            });
            this.TCPlayerVideo.on('playerready', () => {
                console.log('TCPlayer is ready!');
            });
        },
        async fetchCourseDetail(){
            const sessionId = PcCookie.get(Key.jsessIdKey);
            let res = await getCourseDetail(sessionId, this.trainId, this.courseId, this.id)
            let { success, errorCode, body, msg } = res;
            if (success && errorCode == "2000") {
                const { detail, buyCount, totalPeriod, name, videoList } = body.data;
                this.introduction = detail;
                this.buyCount = buyCount;
                this.totalPeriod = totalPeriod;
                this.courseName = name;
                this.videoList = videoList;
                this.hasStudy = this.videoList.filter((item) => item.beStudying == true);
                if (this.hasStudy.length == 0) {
                    this.playVideo = this.videoList[0];
                    this.videoIndex = 0;
                } else {
                    this.videoList.forEach((item, index) => {
                        if (item.beStudying) {
                            this.playVideo = this.videoList[index];
                            this.videoIndex = index;
                        }
                    });
                }
                // 赋值 videoSource
                if (this.playVideo && this.playVideo.coursewareVideo) {
                    this.videoUrl = this.playVideo.coursewareVideo.videoUrl;
                    this.videoId = this.playVideo.coursewareVideo.id;
                    this.videoSource = this.playVideo.coursewareVideo.videoSource;
                }
                // 其他逻辑
                this.currentTime = this.playVideo.playPosition >= this.playVideo.coursewareVideo.totalDuration ? 0 : this.playVideo.playPosition;
                this.playTime = this.playVideo.status === '1' ? Number.POSITIVE_INFINITY : this.playVideo.playPosition;
                this.hasNews = true;
            } else {
                this.$message({
                    message: msg,
                    type: "error",
                });
            }

        },
        //获取课程详情
        // fetchCourseDetail() {
        //     const sessionId = PcCookie.get(Key.jsessIdKey);
        //     getCourseDetail(sessionId,this.trainId, this.courseId,this.id).then((res) => {
        //         let { success, errorCode, body, msg } = res;
        //         if (success && errorCode == "2000") {
        //             const { detail, buyCount, totalPeriod, name, videoList } =
        //                 body.data;
        //             this.introduction = detail;
        //             this.buyCount = buyCount;
        //             this.totalPeriod = totalPeriod;
        //             this.courseName = name;
        //             this.videoList = videoList;
        //             this.hasStudy = this.videoList.filter((item) => {
        //                 return item.beStudying == true;
        //             });
        //             if (this.hasStudy.length == 0) {
        //                 this.playVideo = this.videoList[0];
        //                 this.videoIndex = 0;
        //             } else {
        //                 this.videoList.forEach((item, index) => {
        //                     if (item.beStudying) {
        //                         this.playVideo = this.videoList[index];
        //                         this.videoIndex = index;
        //                     }
        //                 });
        //             }
        //             this.videoUrl = this.playVideo.coursewareVideo.videoUrl;
        //             this.videoId = this.playVideo.coursewareVideo.id;
        //             if(this.playVideo.playPosition >= this.playVideo.coursewareVideo.totalDuration){
        //                 this.currentTime = 0;
        //             }else{
        //                 this.currentTime = this.playVideo.playPosition;
        //             }
        //             if(this.playVideo.status === '1'){
        //                 this.playTime = Number.POSITIVE_INFINITY;
        //             }else{
        //                 this.playTime = this.playVideo.playPosition;
        //             }
        //             // this.buy = res.body.data.buy;
        //             // if (this.buy) {
        //             //     this.autoplay = true;
        //             // } else {
        //             //     this.autoplay = false;
        //             // }
        //             this.hasNews = true;
        //             this.videoSource = this.playVideo.coursewareVideo.videoSource
        //         } else {
        //             this.$message({
        //                 message: msg,
        //                 type: "error",
        //             });
        //         }
        //     });
        // },
        /**
         * 视频相关事件开始
         */
        //视频播放事件
        playFunc() {
            setTimeout(() => {
                this.isPlay = true;
            }, 1000);
            if (this.firstPlay) {
                this.firstPlay = false;
            }
        },
        //视频暂停
        pauseFunc() {
            this.saveTime();
        },
        //播放结束
        playEnded() {
            if (this.videoIndex + 1 != this.videoList.length) {
                this.videoList[this.videoIndex].status = "1";
                const index = this.videoIndex + 1;
                this.videoList.forEach((item) => {
                    item.beStudying = false;
                });
                this.videoList[index].beStudying = true;
                this.playVideo = this.videoList[index];
                //如果下一个视频没看过呢，就直接从零开始播放
                if (this.playVideo.status === "0") {
                    if (this.playVideo.playPosition != 0) {
                        this.changeTime = this.playVideo.playPosition;
                        this.currentTime = this.playVideo.playPosition;
                    } else {
                        this.changeTime = 0;
                        this.currentTime = 0;
                    }
                } else {
                    this.changeTime = this.playVideo.playPosition;
                    this.playVideo.playPosition = 0;
                    this.currentTime = 0;
                }
                this.videoUrl = this.playVideo.coursewareVideo.videoUrl;
                this.videoId = this.playVideo.coursewareVideo.id;
                this.isChange = true;
                this.$refs.videoPlayer.play();
                this.videoIndex = index;
            } else {
                this.currentTime = 0;
            }
        },
        //视频播放时间监听
        onPlayerTimeupdate(player) {
            //看完的课程可以快件后退播放
            if (this.isChange) {
                player.target.currentTime = this.changeTime;
                this.isChange = false;
            }
            if (this.playVideo.status === "0") {
                if (
                    player.target.currentTime - this.currentTime > 2 ||
                    player.target.currentTime - this.currentTime < 0
                ) {
                    player.target.currentTime = this.currentTime;
                } else {
                    this.currentTime = player.target.currentTime;
                }
            } else {
                this.currentTime = player.target.currentTime;
            }
            this.videoList[this.videoIndex].playPosition =
                player.target.currentTime;
        },
        //切换章节学习
        async changeChapter(item, index) {
            this.saveTime();
            this.playVideo = {};
            this.playVideo = this.videoList[index];
            //第一种 播放时间为0 没学习过 -- 不能播放
            //第二种 播放时间不为0
            //2.1 没看完 -- 从指定时间开始播放
            //2.2 看完了 -- 从零开始
            // if (this.playVideo.playPosition != 0) {
            this.currentTime = null;
            this.playTime = null;
            if (
                this.playVideo.playPosition >=
                this.playVideo.coursewareVideo.totalDuration
            ) {
                this.changeTime = 0;
                this.playTime = Number.POSITIVE_INFINITY;
            } else {
                this.changeTime = this.playVideo.playPosition;
                this.playTime = this.playVideo.playPosition;
            }
            this.currentTime = this.playVideo.playPosition;
            this.videoUrl = this.playVideo.coursewareVideo.videoUrl;
            this.videoId = this.playVideo.coursewareVideo.id;
            this.videoSource = this.playVideo.coursewareVideo.videoSource;
            this.videoIndex = index;
            this.isChange = true;
            document.documentElement.scrollTop = 0;
            if(this.videoSource == 'txy'){
                if(this.playVideo.coursewareVideo.id.includes('zyk-')){
                    const sessionId = PcCookie.get(Key.jsessIdKey);
                    const res = await getTxyVideo(sessionId,this.playVideo.coursewareVideo.id)
                    this.TCPlayerVideo.loadVideoByID({
                        fileID:res.body.data.fileId,
                        appID:res.body.data.appId,
                        psign:res.body.data.psign,
                        licenseUrl:res.body.data.licenseUrl
                    })
                }else{
                    this.TCPlayerVideo.loadVideoByID({
                        fileID:this.playVideo.coursewareVideo.fileId,
                        appID:this.playVideo.coursewareVideo.appId,
                        psign:this.playVideo.coursewareVideo.psign,
                        licenseUrl:this.playVideo.coursewareVideo.licenseUrl
                    })
                }
            }
            this.$refs.videoPlayer.play();
            // }
        },
        //保存观看时间
        saveTime() {
            let playPosition = parseInt(this.currentTime);
            const sessionId = PcCookie.get(Key.jsessIdKey);
            saveVideoTime(
                sessionId,
                this.trainId,
                this.courseId,
                this.videoId,
                playPosition
            ).then((res) => {
                if (res.errorCode === "2000") {
                    console.log("观看时间更新成功");
                }
            });
        },
        //浏览器页签切换
        change(evt, hidden) {
            if (hidden) {
                this.$refs.videoPlayer.pause();
            }
        },
        /**
         * 视频相关事件结束
         */
        //相关信息tabs切换
        handleTabsClick(tab) {
            let newsTop = document.getElementById('course_introduce').offsetTop;
            let outlineTop = document.getElementById('course_chapter').offsetTop;
            let hTop = null;
            if(tab.name==='0'){
                hTop = newsTop;
            }else if(tab.name === '1'){
                hTop = outlineTop;
            }
            document.documentElement.scrollTop  = hTop;
            console.log(tab.name);
        },
    },
    watch: {
        // currentTime: {
        //     //当前时间是五分钟的倍数，就暂停
        //     handler(newVal){
        //         const intVal = parseInt(newVal);
        //         if (this.playVideo.status != "1") {
        //             if (intVal % 900 == 0 && this.isPlay && intVal>0) {
        //                 this.$refs.videoPlayer.pause();
        //                 this.isPlay = false;
        //             }
        //         }
        //     },
        //     deep:true
        // },
    },
    beforeDestroy() {
        if(this.TCPlayerVideo){
            this.TCPlayerVideo.dispose();
        }

        this.saveTime();
    },
};
</script>

<style lang="less" scoped>
.notAllowed{
    cursor: not-allowed !important;
}
.shouldNnow {
    font-size: 16px;
    line-height: 32px;
    color: #b21f27;
    margin: 12px;
}
.swiperContent {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;
    > .lecturerImg {
        width: 168px;
        height: 100%;
    }
    > .content {
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12px;
        height: 100%;
        font-size: 14px;
        color: #000;
        line-height: 24px;
        font-family: "微软雅黑";
        > p {
            line-height: 48px;
            height: 48px;
            font-weight: bold;
        }
        > div {
            p {
                margin: 6px 0;
            }
            span {
                max-height: 120px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
            }
        }
    }
}
.video-details-container {
    background: #f8f9fd;
}
</style>
